import { useState } from 'react';
import { Row } from '../../../../../components/Basic/Blocks';
import { Button } from '../../../../../components/Basic/Buttons';
import { Icon } from '../../../../../components/Basic/Elements';
import { Input } from '../../../../../components/Basic/Inputs';
import { TYPE_BUTTONS } from '../../../../../constans';
import sber from '../../../../../assets/media/sber.svg';

const MARKETS = ['MM-1', 'MM-2'];

const MegamarketContentButton = ({ isAdmin = true, onClick = (_) => _ }) => {
  const [minPurchase, setMinPurchase] = useState(100);
  const [market, setMarket] = useState(MARKETS[0]);

  return (
    <Row style={{ marginLeft: '15px', alignItems: 'flex-end' }}>
      {isAdmin && (
        <>
          {' '}
          <Select
            label={'Магазин'}
            select={market}
            list={MARKETS}
            onSelect={(v) => setMarket(v)}
            width={'120px'}
            style={{ marginRight: '20px' }}
          />
          <Input label={'Мин. закупка'} value={minPurchase} width={'80px'} onBlur={(v) => setMinPurchase(v)} style={{ marginRight: '10px' }} />
        </>
      )}
      <Button type={TYPE_BUTTONS.WHITE} onClick={() => onClick(market, minPurchase)}>
        <Icon src={sber} width={'25px'} style={{ marginRight: '10px' }} />
        Перенести в мегамаркет
      </Button>
    </Row>
  );
};
export default MegamarketContentButton;
